<script lang="ts">
  import { getContext } from 'svelte';
  import { browser } from '$app/environment';
  import { fly } from 'svelte/transition';
  import { linear } from 'svelte/easing';
  import { getWrapperStyles } from './helpers/sections-helper';
  import {
    Heading,
    Paragraph,
    Button,
    ShowMoreButton,
    Wrapper,
  } from './components';
  import { moneyFormat } from './helpers/price-helper';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  const isEditable = getContext<boolean>('isEditable') || false;

  $: ({ borderRadius } = settings);
  $: currentItems = isEditable ? properties?.items.length : 3;
  $: items = properties.items.slice(0, currentItems);

  const showMore = () => {
    currentItems = properties.items.length;
  };

  const hideItems = () => {
    currentItems = 3;
  };

  let options = { duration: 300, easing: linear };

  //Remove html tags from string with regex
  const stripHtml = html => {
    try {
      let tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    } catch (e) {
      return html;
    }
  };
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  {#if properties?.items.length}
    <div
      class="cards-section wf-section {properties.cardStyle}"
      style="background:var(--vlt-lp-background); {getWrapperStyles()}"
      id={properties?.anchor}
    >
      <div class="cards-inner-wrap">
        <!-- <div class="section-title">What&#x27;s included?</div>-->
        {#if properties.heading}
          <Heading type={'h2'} css={'margin-bottom:50px;text-align: center;'}
            >{@html properties?.heading}</Heading
          >
        {/if}

        <div
          class="w-layout-grid card-grid"
          class:card-grid-2={items.length === 2}
          class:card-grid-1={items.length === 1}
        >
          {#each items as list}
            <div class="card" transition:fly={{ ...options, y: -10 }}>
              <div
                class="card-image _1"
                style="background-image: url('{list?.image?.url}')"
              />
              <div
                class="card-content"
                style="border-color:var(--vlt-lp-primary);"
              >
                <div class="inner-card-content">
                  {#if list.heading.active}
                    <Heading
                      type={'h3'}
                      css={'font-size: 24px; color: #0E0F11!important; line-height: 30px;'}
                    >
                      {@html list?.heading?.value || ''}
                    </Heading>
                  {/if}

                  {#if list.text.active && browser}
                    <div class="text-block">
                      <Paragraph
                        css={'opacity: 0.75; color:#0E0F11!important; font-size: 16px; line-height: 22px;'}
                      >
                        {stripHtml(list?.text?.value) || ''}
                      </Paragraph>
                    </div>

                    {#if properties.showPrice && list.price}
                      <div class="prices">
                        <p class="service">Starting from</p>
                        <p class="price">
                          <span class="money">$</span>{moneyFormat(list.price)}
                        </p>
                      </div>
                    {/if}

                    {#if list.button.active}
                      <Button
                        {borderRadius}
                        section="service1"
                        buttonType={list.button.link_type}
                        buttonLink={list.button.link}
                        buttonTitle={list.button.label}
                      />
                    {/if}
                  {/if}
                </div>
              </div>
            </div>
          {/each}
        </div>
      </div>
      <ShowMoreButton
        on:showMore={showMore}
        on:showLess={hideItems}
        {currentItems}
        itemsLength={properties.items.length}
        {isEditable}
      />
    </div>
  {/if}
</Wrapper>

<style>
  .prices {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #eaeaeb;
    padding-top: 20px;
  }
  span.money {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 32px;
    margin-right: 2px;
  }
  p.service {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: #0e0f11;
  }
  p.price {
    display: flex;
    align-items: flex-end;
    margin: 0;
    padding: 0;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #0e0f11;
  }
  .cards-section {
    background-color: var(--background-color, #fff);
  }
  .w-layout-grid {
    display: -ms-grid;
    display: grid;
    grid-auto-columns: 1fr;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    -ms-grid-rows: auto auto;
    grid-template-rows: auto auto;
    grid-row-gap: 16px;
    grid-column-gap: 16px;
  }
  .text-block :global(.paragraph) {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 80px;
    color: #0e0f11;
  }

  .cards-inner-wrap {
    width: 100%;
    max-width: 1300px;
  }

  .card {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 20px;
    align-items: center;
  }
  .card-content {
    height: 100%;
  }
  .inner-card-content {
    padding: 20px;
    display: flex;
    height: 100%;
    justify-content: space-between;
    flex-direction: column;
    row-gap: 20px;
  }

  .card-image {
    display: flex;
    width: 100%;
    height: 225px;
    flex-direction: column;
    align-items: center;
    border-style: none;
    border-width: 1px;
    border-color: #dbdbdb;
    background-image: none;
    background-position: 50% 50%;
    background-size: cover;
  }

  .card-image ._1 {
    background-position:
      0 0,
      50% 50%;
    background-size: cover;
  }

  .card-content {
    width: 90%;
    margin-top: -70px;
    min-height: 268px;
    padding: 0;
    display: flex;
    flex-direction: column;
    border-style: solid;
    border-width: 5px 1px 1px;
    background-color: #fff;
  }

  .card-content :global(.heading) {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card-grid {
    margin-top: 30px;
    grid-column-gap: 20px;
    -ms-grid-columns: 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    -ms-grid-rows: auto;
    grid-template-rows: auto;
  }

  .card-grid-2 {
    grid-column-gap: 20px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    margin-top: 30px;
  }

  .card-grid-1 {
    grid-column-gap: 20px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    margin-top: 30px;
    justify-items: center;
  }

  .card-grid-1 .card {
    max-width: 410px;
  }

  .cards-section {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 0 15px;
  }

  @media screen and (max-width: 767px) {
    .card-grid {
      -ms-grid-columns: 1fr;
      grid-template-columns: 1fr;
    }

    .card-grid-1 .card-image {
      height: 225px;
    }

    .card-grid-1 :global(.header-button) {
      width: auto;
    }
  }
</style>
